import React, { Component } from "react";
import SideNav from "../Layout/SideNav";
import Content from "../Layout/Content";
import { connect } from "react-redux";
import { fetchData, cleanData } from "../store/actions";

class CategoryPage extends Component {
  render() {
    return (
      <React.Fragment>
        <SideNav />
        <Content />
        {/* //TODO: */}
        {/* ????? WHERE IS THE DATA COME FROM WHEN CHANGE CATEGORY */}
      </React.Fragment>
    );
  }
  componentWillUnmount() {
    this.props.cleanData();
  }
}
export default connect(null, { fetchData, cleanData })(CategoryPage);
